<template>
  <div class="section-heading">
    <h3 class="cs-textstyle-section-heading section-heading__title">
      {{ title }}
    </h3>
    <div
      v-if="isViewMore"
      class="cs-textstyle-detail-heading section-heading__btn"
    >
      <router-link :to="{ name: to }" active-class=""
        ><a>View All</a></router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    isViewMore: {
      type: Boolean,
      default: true,
    },
    to: {
      type: String,
      default: 'Home',
    },
  },
};
</script>

<style scoped>
.section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 23px;
}
.section-heading__btn a {
  color: var(--cs-accent-dark);
  text-decoration: none;
}
.section-heading__title {
  color: var(--cs-gray-06);
}
</style>
